// extracted by mini-css-extract-plugin
export default {"MainPruf":"MainPruf_MainPruf__WtZTO","MainPruf__block":"MainPruf_MainPruf__block__9t-RM"};